module.exports = __webpack_public_path__ + "999a98e3d0aa29c23faadc276ff2b13a.svg";